<script>
import IconBell from '@/assets/imgs/icons/bell.svg'
import IconChat from '@/assets/imgs/icons/icon-chat.svg'
import NotificationWidget from '@/components/notification/NotificationWidget'
import Notification from '@/components/notification/Notification'
//import OverlayPage from '@/components/OverlayPage.vue'
//import MediaPlayer from '@/components/MediaPlayer.vue'

export default {
  name: 'NotificationButton',
  components: {
    //OverlayPage,
    IconBell,
    IconChat,
    NotificationWidget,
    Notification,
    //MediaPlayer,
  },
  data: () => ({
    notificationActivated: false,
    playAudio: null,
    playVideo: null,
    popups: []
  }),
  computed: {
    list() {
      const list = (this.$store.getters['user/notification/list'] || [])
      const unread = list
        .filter(n => n.readAt.seconds === 0)
        .sort((a,b) => {
          const as = a.createdAt.seconds
          const bs = b.createdAt.seconds
          return as === bs 
            ? 0
            : as > bs
              ? -1
              : 1
        })

      // console.log('notifications', unread)
      return unread
    },
    unread() {
      return this.list.length
    },
    chatNotifications() {
      return this.$store.state.user.dm.notifications
    }
  },
  methods: {
    toggle() {
      this.notificationActivated = !this.notificationActivated
    },
    // play media notification
    async playNotification(notification) {
      const type = this.notificationType(notification)
      const coll = await this.$store.getters['user/notification/collection']()
      const ref = coll.doc(notification.id)
      await ref.update({readAt: new Date()})
      if (type === 'text')
        return
      // console.log('play!', notification, type)
      if (type === 'audio') {
        this.playAudio = notification.content[0].media.url
        await this.$refs.audio.load()
        await this.$refs.audio.play()
      }
      if (type === 'video') {
        this.$store.commit('ui/setVideoNotification',{
          details: {
            url: notification.content[0].media.url,
            filename: notification.content[0].title
          }
        })
      }
    },
    notificationType(notification) {
      const content = notification.content[0]
      return content.text
        ? 'text'
        : content.media
          ? (content.media.originalFormat || content.media.originFormat || '').startsWith('audio')
            ? 'audio'
            : 'video'
          : 'unknown'
    },


  },
  watch: {
    'list'(next, prev) {
      // console.log('watch unread', [next, prev])
      if (!Array.isArray(next) || !Array.isArray(prev))
        return
      if (next.length < prev.length)
        return
      const diff = next.filter(el => !prev.find(ell => el.id === ell.id))
      diff.reverse().forEach(notification => {
        // console.log('new notifications!', notification)
        this.popups.push(notification)
        // play immidiate media notifications
        if (notification.immediate) {
          this.playNotification(notification)
        }
        setTimeout(() => {
          this.popups.shift()
        }, 15000)
      })
    }
  }
}
</script>

<template>
<div class="notification-button-wrapper">
  <audio 
    class="d-none"
    :src="playAudio"
    ref="audio" />
  <button @click.stop="toggle()" class="overlay-ui-icon-button" id="button-bell">
    <IconBell/>
    <span class="icon-tooltip">{{$t('hoverLabels.notification')}}</span>
    <span class="unread" v-if="unread > 0">{{unread}}</span>
  </button>
  <NotificationWidget
    v-if="notificationActivated"
    :isOpen="notificationActivated"
    @widgetClose="notificationActivated = !notificationActivated"
    @notification="playNotification"
  />

  <!--
  <OverlayPage class="activity-overlay"
    v-if="playVideo"
    @close="playVideo = null"
  >
{{playVideo}}
  <MediaPlayer
    :file="playVideo"
    autoplay
    :type="5"
  />
  </OverlayPage>
  -->
  <div class="notifications-popups">
    <div v-for="popup of popups" :key="popup.id" class="notification-popup pa-2 bg-white border rounded elevation-2">
      <Notification
        :notification="popup"
        @closeMe="popups = popups.filter(el => el.id !== popup.id)"
        @activate="popups = popups.filter(el => el.id !== popup.id); playNotification(popup)"
      />
    </div>
    <div v-for="popup, pi of chatNotifications" :key="pi" class="notification-popup pa-2 bg-white border rounded elevation-2 d-flex">
      <IconChat/>
      <div :innerHTML="$t('notification.newMessage',{ from: popup.displayName})"/>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">

.notifications-popups {
  position: absolute;
  top: 50px;
  right: 30px;
  width: 250px;
  z-index: 1;
}

.unread {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: rgb(var(--v-theme-fb-navy));
  color: rgb(var(--v-theme-white));
  font-size: 60%;
  padding-top: 4px;
}

.icon-tooltip{
  color: rgb(var(--v-theme-black));
  background-color: rgb(var(--v-theme-white));
  position: absolute;
  padding: 4px 10px;
  border-radius: 4px;
  z-index: 2;
  opacity: 0;
  transition: all 0.5s;
  pointer-events: none;
  white-space: nowrap;
}

#button-bell {
  svg {
    //top: 10px;
  }
  .icon-tooltip{
    right:130%;
    top:50%;
    transform:translateY(-50%);
  }
  &:hover{
    .icon-tooltip{
      right:115%;
    }
  }
}


</style>
